export default __webpack_public_path__ + "static/media/ultimatewatercreations.1bc98712.png";